import React from 'react'
import useLogout from '_hooks/useLogout'

const LogoutCard = () => {
  const handleLogout = () => {
    useLogout()
  }

  return (
    <div className='section-card logout-card' onClick={handleLogout}>
      <div className='logout-row'>
        <div className='logout-left'>
          <div className='logout-icon'>
            <svg
              width='15'
              height='15'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <path d='M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4' />
              <polyline points='16 17 21 12 16 7' />
              <line x1='21' y1='12' x2='9' y2='12' />
            </svg>
          </div>
          <div className='logout-label'>Log Out</div>
        </div>
        <svg
          width='14'
          height='14'
          viewBox='0 0 24 24'
          fill='none'
          stroke='#E24B4A'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <polyline points='9 18 15 12 9 6' />
        </svg>
      </div>
    </div>
  )
}

export default LogoutCard
